<template lang="pug">
	.contenedor.bg-light
		.titulo
			span.fa.fa-download.mr-2
			| Archivos adjuntos ({{datos.Archivos.length}})
			button.btn.btn-sm.btn-primary.ml-3(@click="verTodos = !verTodos")
				span.mr-2.fa(:class="(verTodos) ? 'fa-caret-up' : 'fa-caret-down'")
				span(v-if="verTodos") Ocultar
				span(v-else) Mostrar
		div(v-if="verTodos")
			.fichero(v-for="archivo in datos.Archivos", @click="download(archivo)")
				.icono
					span(:class="(archivo.Icono) ? archivo.Icono : 'fa fa-file'")
				.nombre {{archivo.Nombre}}
				.tamano {{archivo.Tamano}}
</template>

<script>
export default {
	props: ['datos'],
	data () {
		return {
			verTodos: false
		}
	},
	methods: {
		download (archivo) {
			window.location.href = '/src/modulos/muro/php/api/download.php?ArchivoID=' + archivo.ArchivoID
		}
	}
}
</script>

<style scoped>
.contenedor {
	position: relative;
	display: block;
	padding-top: 10px;
	padding-bottom: 10px;
	border: 1px solid #e0e0e0;
}

.titulo {
	margin: 5px;
	margin-left: 10px;
	font-size: 1.3em;
}

.fichero:hover {
	color: blue;
	text-decoration: underline;
}
.fichero {
	cursor: pointer;
	position: relative;
	display: flex;
	flex-direction: row;
	align-content: flex-start;
	align-items: flex-start;
	flex-wrap: nowrap;
	margin: 5px;
	margin-bottom: 0;
}

.icono {
	position: relative;
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 0;
	padding: 5px;
	min-width: 40px;
	max-width: 40px;
	align-content: center;
	align-items: center;
	align-self: center;
}

.nombre {
	position: relative;
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 0;
	padding: 5px;
	align-content: center;
	align-items: center;
	align-self: center;
}

.tamano {
	position: relative;
	flex-grow: 1;
	flex-shrink: 0;
	flex-basis: 0;
	padding: 5px;
	text-align: right;
	align-content: center;
	align-items: center;
	align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/publicacion/contenidoArchivo.vue